import React, { useEffect, ComponentProps } from "react";
import * as S from "./styles";

interface ButtonCustomProps extends ComponentProps<"button"> {}

export const Button = (props: ButtonCustomProps) => {
  return <S.ButtonLogin {...props} $disabled={props.disabled} />;
};
